import {
  GET_ASSESSMENT_BY_ID,
  GET_ASSESSMENT_BY_ID_SUCCESS,
  GET_ASSESSMENT_BY_ID_ERROR
} from './constants';

// Trigger a fetch of an Assessment template by id. The saga short-
// circuits when the id is already cached in templatesById to avoid
// re-fetches on every render. `force: true` overrides the cache —
// useful after a trainer edits their own custom template and wants
// the renderer to pick up the new question set without a page
// reload (a Phase 4+ use case; PR 1 always uses the cache).
export function getAssessmentById(id, { force = false } = {}) {
  return { type: GET_ASSESSMENT_BY_ID, id, force };
}

export function getAssessmentByIdSuccess(assessment) {
  return { type: GET_ASSESSMENT_BY_ID_SUCCESS, assessment };
}

export function getAssessmentByIdError(id, err) {
  return { type: GET_ASSESSMENT_BY_ID_ERROR, id, err };
}